<template>
  <div class="customer">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="备注"
        width="500px"
        top="5vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          class="form"
          label-width="10px">
        <el-form-item label="">
          <el-input v-model="model.note" type="textarea" :rows="3"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name:"AttachedNoteEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        model: {
          id: 0,
          note: "",
        },
      };
    },
    methods: {
      open(id) {
        this.model.id = id;
        this.dialogVisible = true;
        if(id > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `applications/attached/${this.model.id}`)
          .then(resp => {
            this.model = resp;
          });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .put("basic", "applications/attachedUpdate", this.model)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss">
</style>
